import { render, staticRenderFns } from "./DailySeparator.vue?vue&type=template&id=a70545d6&"
import script from "./DailySeparator.vue?vue&type=script&lang=js&"
export * from "./DailySeparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports